import { toNativePromise } from '../../commonInfra/utils/QUtils';
import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { Filter } from '../../ts/helpers/Filter';
import { IDetailResource, IListResource } from '../../ts/resources/Resource';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import { GetUserNamesRequest } from '../../ts/ServerApi/requests/GetUserNamesRequest';
import { ILeafFilterClause } from '../../ts/ServerApi/types/IFilterClause';
import { IUserName } from '../../ts/ServerApi/types/IUser';
import { NamedItemKeys } from '../../ts/ServerApi/types/resourceParts';

export class UserNamesResource implements IListResource<IUserName>, IDetailResource<IUserName> {
  private listFetcher = new WebClientListResourceFetcher(GetUserNamesRequest, result => result.users);

  public all(): ResourceQuery<IUserName> {
    return new ResourceQuery(this.listFetcher);
  }

  public getById(id: string, additionalFilterClauses?: ILeafFilterClause[]): Promise<IUserName> {
    return toNativePromise(
      this.all()
        .withFilters(additionalFilterClauses ?? [])
        .addFilter(Filter.stringFieldEq(NamedItemKeys.id, id))
        .getFirst()
    );
  }
}

export const UserNames = new UserNamesResource();
